const layouts = {
  lg: [
    {i: 'a', x: 0, y: 0, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'b', x: 1, y: 0, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'c', x: 2, y: 0, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'd', x: 0, y: 1, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'e', x: 1, y: 1, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'f', x: 2, y: 1, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'g', x: 0, y: 2, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'h', x: 1, y: 2, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'i', x: 2, y: 2, w: 1, h: 2, minW: 1, maxW: 1},
  ],
  md: [
    {i: 'a', x: 0, y: 0, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'b', x: 1, y: 0, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'c', x: 2, y: 0, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'd', x: 0, y: 1, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'e', x: 1, y: 1, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'f', x: 2, y: 1, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'g', x: 0, y: 2, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'h', x: 1, y: 2, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'i', x: 2, y: 2, w: 1, h: 2, minW: 1, maxW: 1},
  ],
  sm: [
    {i: 'a', x: 0, y: 0, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'b', x: 1, y: 0, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'c', x: 0, y: 1, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'd', x: 1, y: 1, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'e', x: 0, y: 2, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'f', x: 1, y: 2, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'g', x: 0, y: 3, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'h', x: 1, y: 3, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'i', x: 0, y: 4, w: 1, h: 2, minW: 1, maxW: 1},
  ],
  xs: [
    {i: 'a', x: 0, y: 0, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'b', x: 0, y: 1, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'c', x: 0, y: 2, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'd', x: 0, y: 3, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'e', x: 0, y: 4, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'f', x: 0, y: 5, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'g', x: 0, y: 6, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'h', x: 0, y: 7, w: 1, h: 2, minW: 1, maxW: 1},
    {i: 'i', x: 0, y: 8, w: 1, h: 2, minW: 1, maxW: 1},
  ]
}

export default layouts